import { createMockCreator } from "../../../common/_mocks/mockUtils";
import { registrationNumberAlertMock } from "../../../common/registrationNumberAlert/_mocks/registrationNumberAlertMock";
import type { CreateCandidate } from "../createFormReducer";

export const createCandidateMock: CreateCandidate = {
  goods: {},
  empty: false,
  customerRef: "customer ref",
  customsClassification: {
    label: "customs classification",
    value: "customs classification",
  },
  hasAnimals: true,
  hasElectricalPlugin: true,
  hasHazardousGoods: true,
  height: 0,
  length: 0,
  livestockType: {
    label: "animal",
    value: "animal",
  },
  loadingListMessage: "loading list message",
  loadingPreference: {
    label: "loading preference",
    value: "loadingPreference",
  },
  meta: {
    errors: [],
    warnings: [],
  },
  numberOfDrivers: 2,
  pluginTemperature: "3",
  receiverCountry: {
    id: "GB",
    label: "United Kingdom",
    value: "GB",
    validTo: "",
    isValid: true,
  },
  registrationNumberAlert: registrationNumberAlertMock,
  senderCountry: {
    id: "NL",
    label: "Netherlands",
    value: "NL",
    validTo: "",
    isValid: true,
  },
  trailerReg: "trailer reg",
  vehicleReg: "vehicle reg",
  vehicleType: null,
  width: 0,
  exportReference: "",
  importReference: "",
};

export const createCreateCandidateMock = createMockCreator(createCandidateMock);
